<!-- Container que decide qué versión renderizar según el flujo -->
<app-sales-credit-summary-kredicash-v3
  *ngIf="isFlowKrdya"
  (nextStepEvent)="onNextStep()"
  (gotoStepEvent)="onGotoStep($event)">
</app-sales-credit-summary-kredicash-v3>

<app-sales-credit-summary-kredicash-v2
  *ngIf="!isFlowKrdya"
  (nextStepEvent)="onNextStep()"
  (gotoStepEvent)="onGotoStep($event)">
</app-sales-credit-summary-kredicash-v2>
